import {BaseModel} from '../common/base/base-model';

export class LawConservationFrequency extends BaseModel {
  value: string;
  name: string;
}
